import  ActionType from './ActionType';
import { IAction } from './Action';
import { IGetProjectPath, IGetCustomProject, IGetProject } from '../Models/IGetProject';
import { IGetDataset } from '../Models/IGetDataset';

export interface IProjectContentState {
  loadingProjectAndParent: boolean;
  loadingProjectContent: boolean;
  projectContentDialogIsOpen: boolean;
  projectContentDialogIsSelectable: boolean;
  project: IGetProject | null;
  projectParent: IGetProject | null;
  projectContent: (IGetProject | IGetDataset | IGetCustomProject)[];
  currentNavigationProject: IGetProject;
  currentNavigationParentProject: IGetProject;
  currentNavigationProjectPath: IGetProjectPath[];
  page: number;
  rowsPerPage: number;
  order: 'asc' | 'desc';
  orderBy: string | ((item: any) => string | number);
}

export const initState = {
  loadingProjectAndParent: false,
  loadingProjectContent: false,
  project: null,
  projectParent: null,
  projectContent: Array<IGetProject | IGetDataset>(),
  currentNavigationProject: null,
  currentNavigationParentProject: null,
  currentNavigationProjectPath: Array<IGetProjectPath>(),
  projectContentDialogIsOpen: false,
  projectContentDialogIsSelectable: false,
  page: 0,
  rowsPerPage: 10,
  order: 'asc',
  orderBy: '',
};

export const projectContent = (state = initState, action: IAction<any>) => {
  switch (action.type) {
    case ActionType.OPEN_PROJECTCONTENT_DIALOG:
      return {
        ...state,
        projectContentDialogIsOpen: action.data,
        projectContentDialogIsSelectable: action.data.selectable,
      };
    case ActionType.LOADING_PROJECTANDPARENT:
      return { ...state, loadingProjectAndParent: action.data };
    case ActionType.LOADING_PROJECTCONTENT:
      return { ...state, loadingProjectContent: action.data };
    case ActionType.SET_PROJECTCONTENT: {
      return {
        ...state,
        projectContent: action.data.projectContent,
        currentNavigationProject: action.data.project,
        currentNavigationProjectPath: action.data.path,
        loadingProjectContent: false,
      };
    }
    case ActionType.SET_PROJECTANDPARENT:
      console.log('SET_PROJECTANDPARENT ', action.data);
      return {
        ...state,
        project: action.data,
        projectParent: action.data,
        loadingProjectAndParent: false,
      };
    case ActionType.SET_PROJECTCONTENT_PAGE:
      return {
        ...state,
        page: action.data,
      };
    case ActionType.SET_PROJECTCONTENT_ROWSPERPAGE:
      return {
        ...state,
        rowsPerPage: action.data,
      };
    case ActionType.SET_PROJECTCONTENT_ORDER:
      return {
        ...state,
        order: action.data,
      };
    case ActionType.SET_PROJECTCONTENT_ORDERBY:
      return {
        ...state,
        orderBy: action.data,
      };

    default:
      return state;
  }
};
